<header class="page-head" data-testid="fractionations-section">
  <div class="page-head__identity">
    <span class="page-head__icon"><i class="fa fa-list-alt"></i></span>
    <div>
      <h1 class="page-head__title">Fracionamentos</h1>
      <p class="page-head__subtitle">
        Cadastro e gerenciamento de rotas por canal: como o tráfego de cada operadora se divide entre
        as contas de provedor.
      </p>
    </div>
  </div>
  <div class="page-head__actions">
    <button
      type="button"
      class="sf-btn sf-btn--primary sf-btn--pill sf-btn--icon-right"
      (click)="newRoute()"
      data-testid="btn-new-route"
    >
      {{ isRcs ? 'Nova rota RCS' : 'Adicionar configuração' }} <i class="fa fa-plus-circle"></i>
    </button>
  </div>
</header>

<!-- Tabs de canal (RCS, 17tm466frtx): a SMS é a lista de sempre; a RCS é só do Admin, como a tela toda. -->
<div class="sf-btn-group channel-tabs" role="tablist" aria-label="Canal" data-testid="channel-tabs">
  <button type="button" role="tab" class="sf-btn sf-btn--sm" *ngFor="let option of channels"
    [class.is-active]="channel === option.value" [attr.aria-selected]="channel === option.value"
    (click)="selectChannel(option.value)" [attr.data-testid]="'tab-' + option.value">
    {{ option.label }}
  </button>
</div>

<div class="alert alert-info route-notice" *ngIf="isRcs" data-testid="rcs-notice">
  <i class="fa fa-info-circle"></i>
  <span>
    Só entram os provedores RCS <strong>liberados pelo time de desenvolvimento</strong> (conta RCS própria, separada
    das contas de SMS). Na hora do envio a rota fica só com os provedores onde a marca do cliente está
    <strong>ativa</strong>, e as porcentagens são redistribuídas entre eles. Sem nenhum, o RCS não sai e o Admin
    recebe alerta. O cliente não vê rota nem provedor: as rotas RCS dele são escolhidas aqui e no cadastro do usuário.
  </span>
</div>

<section class="released-providers" *ngIf="isRcs" data-testid="rcs-released-providers">
  <h2 class="released-providers__title">Provedores RCS liberados</h2>
  <p class="released-providers__hint">
    Provedor novo entra por código (integração nova + liberação no sistema), não por este painel.
  </p>
  <ul class="released-providers__list" *ngIf="releasedProviders?.length; else noneReleased">
    <li *ngFor="let provider of releasedProviders" class="m8v-status-pill m8v-status-pill--sm m8v-status-pill--cool"
      data-testid="rcs-released-provider">{{ provider.name }}</li>
  </ul>
  <ng-template #noneReleased>
    <p class="released-providers__empty" data-testid="rcs-released-empty">
      {{ releasedProviders === null ? 'Carregando…' : 'Nenhum provedor RCS liberado. O RCS não sai até o desenvolvimento liberar um.' }}
    </p>
  </ng-template>
</section>

<div class="m8v-filter-bar" data-testid="fractionations-filter-bar">
  <div class="m8v-search grow">
    <i class="fa fa-search ic"></i>
    <input
      type="text"
      class="form-control"
      placeholder="Buscar rota pelo nome"
      name="filter"
      id="filter"
      [(ngModel)]="filterText"
      (keyup.enter)="searchRoutes()"
      data-testid="input-filter"
    />
    <button type="button" class="go" (click)="searchRoutes()" title="Pesquisar" data-testid="btn-search">
      <i class="fa fa-chevron-right"></i>
    </button>
  </div>
</div>

<app-skeleton
  *ngIf="loading"
  variant="table-row"
  [count]="6"
  [columns]="3"
  label="Carregando as rotas"
  data-testid="fractionations-loading"
></app-skeleton>

<div
  *ngIf="!loading && (!result?.data || result.data.length === 0)"
  class="m8v-empty"
  data-testid="fractionations-empty"
>
  <i class="fa fa-list-alt ic"></i>
  <h3>Nenhuma rota encontrada</h3>
  <p *ngIf="filterText">Nenhuma rota bate com "{{ filterText }}".</p>
  <p *ngIf="!filterText && !isRcs">Adicione a primeira configuração de rota.</p>
  <p *ngIf="!filterText && isRcs">Nenhuma rota RCS ainda. Crie a primeira para poder apontar os clientes para ela.</p>
  <div class="acts">
    <button type="button" class="sf-btn sf-btn--primary sf-btn--sm" (click)="newRoute()" data-testid="btn-empty-new-route">
      <i class="fa fa-plus-circle"></i> {{ isRcs ? 'Nova rota RCS' : 'Adicionar configuração' }}
    </button>
  </div>
</div>

<div class="m8v-row-list" *ngIf="!loading && result?.data?.length > 0">
  <div
    class="m8v-row-card"
    *ngFor="let route of result.data; trackBy: trackByRouteId"
    [class.is-cancelled]="!route.active"
    [class.tone-ok]="route.default"
    [class.tone-violet]="route.pix"
    data-testid="route-card"
  >
    <span class="m8v-row-avatar"><i class="fa fa-list-alt"></i></span>

    <div class="info">
      <div class="name">
        <a class="m8v-name-link" (click)="redirectToEdit(route)" data-testid="route-name-link">{{ route.name }}</a>
        <span class="m8v-status-pill m8v-status-pill--sm m8v-status-pill--ok" *ngIf="route.default">
          <span class="dot"></span>Padrão do sistema
        </span>
        <span class="m8v-status-pill m8v-status-pill--sm m8v-status-pill--cool" *ngIf="route.monitored">
          <span class="dot"></span>Monitorada
        </span>
        <span class="m8v-status-pill m8v-status-pill--sm m8v-status-pill--violet" *ngIf="route.pix">
          <span class="dot"></span>Pix
        </span>
        <span class="m8v-status-pill m8v-status-pill--sm m8v-status-pill--danger" *ngIf="!route.active">
          Inativa
        </span>
      </div>
    </div>

    <div class="icon-group">
      <button
        type="button"
        class="sf-btn sf-btn--icon sf-btn--sm"
        [ngClass]="route.monitored ? 'sf-btn--primary' : 'sf-btn--secondary'"
        (click)="turnMonitoredRoute(route)"
        ngbTooltip="{{ route.monitored ? 'Deixar de ser monitorada' : 'Tornar monitorada' }}"
        data-testid="btn-monitored"
      >
        <i class="fa" [ngClass]="route.monitored ? 'fa-eye-slash' : 'fa-eye'"></i>
      </button>

      <button
        type="button"
        class="sf-btn sf-btn--icon sf-btn--sm"
        [ngClass]="route.pix ? 'sf-btn--primary' : 'sf-btn--secondary'"
        (click)="turnPixRoute(route)"
        ngbTooltip="{{ route.pix ? 'Deixar de ser pix' : 'Tornar pix' }}"
        data-testid="btn-pix"
      >
        <img src="/assets/pix.gif" width="14" height="14" alt="Pix" style="vertical-align: middle" />
      </button>

      <button
        type="button"
        class="sf-btn sf-btn--icon sf-btn--sm"
        [ngClass]="route.default ? 'sf-btn--primary' : 'sf-btn--secondary'"
        (click)="turnDefaultRoute(route)"
        ngbTooltip="{{ route.default ? 'Deixar de ser padrão' : 'Tornar padrão' }}"
        data-testid="btn-default"
      >
        <i class="fa" [ngClass]="route.default ? 'fa-star-half-o' : 'fa-star'"></i>
      </button>

      <button
        type="button"
        class="sf-btn sf-btn--secondary sf-btn--icon sf-btn--sm"
        (click)="redirectToEdit(route)"
        ngbTooltip="Editar"
        data-testid="btn-edit"
      >
        <i class="fa fa-pencil"></i>
      </button>

      <button
        type="button"
        class="sf-btn sf-btn--secondary sf-btn--icon sf-btn--sm"
        (click)="changeGroupActive(route)"
        ngbTooltip="{{ route.active ? 'Desativar' : 'Ativar' }}"
        data-testid="btn-toggle-active"
      >
        <i class="fa" [ngClass]="route.active ? 'fa-power-off' : 'fa-play'"></i>
      </button>
    </div>
  </div>
</div>

<app-pagination
  *ngIf="!loading && result"
  [currentPage]="result.current_page"
  [itemsPerPage]="result.per_page"
  [totalItems]="result.total"
  (pageChanged)="pageChanged($event)"
></app-pagination>
